/**
 * Ask Anything. A30.
 *
 * The chips narrow the answers already on the page. No fetch — fourteen
 * answers are a page, not a database, and the count says how many are left.
 */

const qa = document.querySelector('[data-qa]');
if (qa) {
  const bar = qa.querySelector('[data-qa-bar]');
  const items = [...qa.querySelectorAll('[data-qa-item]')];
  const count = qa.querySelector('[data-qa-count]');

  const apply = (cat) => {
    let shown = 0;
    items.forEach((item) => {
      const on = !cat || item.dataset.cat === cat;
      item.hidden = !on;
      if (on) shown += 1;
    });
    if (count) {
      const template = shown === 1 ? count.dataset.one : count.dataset.other;
      count.textContent = (template || '').split('%count%').join(String(shown));
    }
  };

  bar?.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-cat]');
    if (!chip) return;
    bar.querySelectorAll('[data-cat]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
    apply(chip.dataset.cat);
  });

  apply('');
}
